export enum Theme {
  Light = "light",
  Dark = "dark",
  HighContrastLight = "high-contrast-light",
  HighContrastDark = "high-contrast-dark",
}
